module.exports = (__parcel__import__("ePp67")).then(() => parcelRequire('ieIpp'));